export default function () {
  const form = document.getElementById('js-form');
  const inputs = form.getElementsByClassName('js-input');
  const items = document.getElementsByClassName('js-item');
  const noresults = document.getElementsByClassName('js-noresults');


  /**
   * Returns an array with filter arrays:
   * [
   *  [filtername, filtervalue],
   *  [filtername2, filtervalue2]
   * ]
   */
  function getFilters() {
    return Array.from(inputs).reduce((filters, input) => {
      if (input.value) filters.push([input.name, input.value]);
      return filters;
    }, []);
  }

  /**
   * Will filter the items and update the display in the dom
   */
  function filterItemsAndUpdateDOM(){
    const filters = getFilters();
    let activeItemsCount = 0;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      let isItemHidden = false;

      for (let j = 0; j < filters.length; j++) {
        const [filterName, filterValue] = filters[j];
        if (item.dataset[filterName] === undefined || item.dataset[filterName] !== filterValue) {
          // No data on the element or no match
          isItemHidden = true;
          break;
        }
      }

      activeItemsCount += isItemHidden ? 0 : 1;
      item.classList.toggle('hidden', isItemHidden);
    }
    noresults[0].classList.toggle('hidden', activeItemsCount != 0);
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    filterItemsAndUpdateDOM();
  })

}
